import React, { useEffect, useRef, useState } from 'react';
import './MeetingForm.css';
import '../../Consultation/ConsultForm/ConsultForm.css';
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PhoneInput } from "react-international-phone";
import Heading from '../../../utls/Heading';

const MeetingForm = () => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        FName: "",
        LastName: "",
        Email: "",
        Company: "",
        Sales: "",
        Message: "",
        Number: "",
        Location: "",
        EventType: "",
        EventDate: "",
    });

    const resetForm = () => {
        setFormData({
            FName: "",
            LastName: "",
            Email: "",
            Company: "",
            Sales: "",
            Message: "",
            Number: "",
            Location: "",
            EventType: "",
            EventDate: "",
        });
    };

    const handlePhoneChange = (phone) => {
        setFormData((prev) => ({
            ...prev,
            Number: phone || "", // Ensure phone is a string
        }));
    };
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [responseMessage, setResponseMessage] = useState(null);

    const validateForm = () => {
        const errors = [];

        // Required field validation
        if (!formData.FName.trim()) errors.push("First Name is required");
        if (!formData.LastName.trim()) errors.push("Last Name is required");
        if (!formData.Email.trim()) errors.push("Email is required");
        if (!formData.Number.trim()) errors.push("Phone Number is required");
        if (!formData.Location.trim()) errors.push("Location is required");
        if (!formData.EventType.trim()) errors.push("EventType is required");
        if (!formData.EventDate.trim()) errors.push("EventDate is required");

        // Email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (formData.Email && !emailRegex.test(formData.Email)) {
            errors.push("Please Enter A Valid Email Address");
        }

        // Phone number validation (basic check for minimum length)
        if (formData.Number && formData.Number.length < 10) {
            errors.push("Please Enter A Valid Phone Number");
        }

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate form before submission
        const validationErrors = validateForm();

        if (validationErrors.length > 0) {
            // Show only the first error message to avoid multiple toasts
            toast.error(validationErrors[0]);
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(
                "https://blueberry-travel.com/api/APIUser/SubmitEnquiryBBTConsultion",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                }
            );

            const data = await response.json(); // Parse JSON response

            if (response.ok) {
                toast.success(data.Message || "Form submitted successfully!"); // Use data.Message
                resetForm();
            } else {
                toast.error(data.Message || "Failed To Submit The Form. Please Try Again Later.");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("An Error Occurred While Submitting The Form.");
        } finally {
            setLoading(false);
        }
    };



    return (
        <>
            <div className="consult-form">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 d-flex flex-column justify-content-center">
                            <Heading className='customheadings'><span>Book </span>Your Consultation Today!
                            </Heading>
                            <p className='book-txt'>Ready to create an unforgettable experience? From concept to execution, enjoy customized solutions to ensure your event’s success. Book a consultation today and bring your vision to life!
                            </p>
                        </div>

                        <div className="col-lg-6">
                            <form className="form-container consultform-container" onSubmit={handleSubmit}>
                                <div className="consult-form-row">
                                    <div className="form-field">
                                        <input
                                            type="text"
                                            name="FName"

                                            value={formData.FName}
                                            onChange={(e) =>
                                                setFormData({ ...formData, FName: e.target.value })
                                            }
                                            required
                                        />
                                        <label htmlFor="firstName">First Name<span>*</span></label>
                                    </div>
                                    <div className="form-field">
                                        <input
                                            type="text"
                                            name="LastName"

                                            value={formData.LastName}
                                            onChange={(e) =>
                                                setFormData({ ...formData, LastName: e.target.value })
                                            }
                                            required
                                        />
                                        <label htmlFor="lastName">Last Name<span>*</span></label>
                                    </div>
                                </div>
                                <div className="consult-form-row">
                                    <div className="form-field">
                                        <PhoneInput
                                            country={"gb"}
                                            value={formData.Number}
                                            onChange={handlePhoneChange}
                                            inputClassName="form-control"
                                            containerClass="phone-input-container"
                                            className="consult-phone-container"
                                            inputProps={{
                                                name: "Number",
                                                required: true,
                                                placeholder: "Phone Number",
                                            }}
                                            enableSearch={true}
                                            preferredCountries={["gb", "us", "in"]}
                                        />
                                        <label htmlFor="mobileNumber" className='label2'>Mobile Number<span>*</span></label>
                                    </div>
                                    <div className="form-field">
                                        <input
                                            type="text"
                                            name="Email"

                                            value={formData.Email}
                                            onChange={(e) =>
                                                setFormData({ ...formData, Email: e.target.value })
                                            }
                                            required
                                        />
                                        <label htmlFor="email" className='label7'>E-mail Address<span>*</span></label>
                                    </div>
                                </div>
                                <div className="consult-form-row">
                                    <div className="form-field">
                                        <input
                                            type="text"
                                            name="EventType"

                                            value={formData.EventType}
                                            onChange={(e) =>
                                                setFormData({ ...formData, EventType: e.target.value })
                                            }
                                            required
                                        />
                                        <label htmlFor="mobileNumber" className='label5'>Event Type<span>*</span></label>
                                    </div>
                                    <div className="form-field">
                                        <input
                                            type="text"
                                            name="Location"

                                            value={formData.Location}
                                            onChange={(e) =>
                                                setFormData({ ...formData, Location: e.target.value })
                                            }
                                            required
                                        />
                                        <label htmlFor="email" className='label6'>Event Location<span>*</span></label>
                                    </div>
                                </div>
                                <div className="consult-form-row consult-form-row2 full-width">
                                    <div className="form-field">
                                        <input
                                            type="date"
                                            name="EventDate"
                                            value={formData.EventDate}
                                            min={new Date().toISOString().split("T")[0]} // Restrict past dates
                                            onChange={(e) => setFormData({ ...formData, EventDate: e.target.value })}
                                            required
                                            onKeyDown={(e) => e.preventDefault()} // Prevent manual typing
                                            pattern="\d{4}-\d{2}-\d{2}" // Ensures correct format
                                            onClick={(e) => {
                                                if (e.target.showPicker) {
                                                    e.target.showPicker(); // Open calendar only if supported
                                                }
                                            }}
                                        />
                                        <label htmlFor="email" className='label8'>Preferred Event Date<span>*</span></label>
                                    </div>


                                </div>
                                {/* <div className="terms-container d-flex justify-content-start align-items-start consult-form-row">
                                    <input type="checkbox" id="terms" className="checkbox-input" />
                                    <p className='text-dark'>Agree to <span>T&C</span> of Blueberry Travel.</p>
                                </div> */}
                                <div className="carouselCaption consult-enquir-btn">
                                    {/* <button className="btn fs4 fw-bold bg-transparent text-black text-uppercase leeter">
                                        Book Now
                                    </button> */}
                                    <button className="btn fs4 fw-bold bg-transparent text-black text-uppercase leeter" type="submit" disabled={loading} >
                                        {loading ? 'Loading...' : 'BOOK NOW'}
                                    </button>
                                </div>
                            </form>
                            <ToastContainer
                                position="top-center"
                                autoClose={3000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                style={{ zIndex: 9999999999 }}
                            />
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default MeetingForm